var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    attrs: {
      "id": "repNav"
    }
  }, [_c('div', {
    staticClass: "logo"
  }, [_vm.isEnrollPrime ? _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('img', {
    attrs: {
      "src": "https://corenroll-logo.s3.us-east-2.amazonaws.com/light-nuera.png",
      "alt": "enroll-prime",
      "width": "160"
    }
  })]) : _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('img', {
    staticClass: "corenroll-logo",
    attrs: {
      "src": require("../assets/images/corenroll_logo_dark.svg"),
      "alt": "corenroll-logo"
    }
  })])])]);
}
var staticRenderFns = []

export { render, staticRenderFns }